<!-- <p>events works!</p> -->
<div class="main-events-div ">
	<div class="alignRow">
		<span style="font-size: large; font-weight: bolder;">Events</span>
		<span class="toolbar-spacer"></span>
		<span style="margin-right: 0.5em;"
			*ngIf="(formattedStartDate && formattedEndDate) && formattedStartDate != formattedEndDate">{{
			formattedStartDate }} - {{ formattedEndDate }}</span>
		<span style="margin-right: 0.5em;"
			*ngIf="(formattedStartDate && formattedEndDate) && formattedStartDate == formattedEndDate">{{
			formattedStartDate }}</span>
		<span *ngIf="!isFiltering && !filterData.Acknowledged && !filterData.Unacknowledged"
			style="margin-right: 0.5em;"> Showing Events from the Past 30
			days</span>
		<span *ngIf="!isFiltering && filterData.Acknowledged" style="margin-right: 0.5em;"> Showing Acknowledged Events
			from the Past 30
			days</span>
		<span *ngIf="!isFiltering && filterData.Unacknowledged" style="margin-right: 0.5em;"> Showing Unacknowledged
			Events from the Past 30
			days</span>
		<mat-icon style="cursor: pointer;" *ngIf="formattedStartDate && formattedEndDate"
			(click)="resetQueryDates()">close</mat-icon>
		<div class="date-picker-div">
			<button mat-raised-button [matMenuTriggerFor]="timeMenu">
				<span>Date Range</span>
				<mat-icon>access_time</mat-icon>
			</button>
			<button *ngIf="selectedTab != 3" mat-raised-button class="filter-button" [matMenuTriggerFor]="filterMenu">
				<span>Filters</span>
				<mat-icon>tune</mat-icon>
			</button>
		</div>
	</div>
	<mat-menu #timeMenu="matMenu">
		<div style="margin: 1em;">
			<!-- <ejs-daterangepicker class="calendar" placeholder="'Pick a date range..." format="dd/MM/yyyy"
				(change)="DatePickerChange($event)" [max]="today" [presets]="datePickerPresets" (click)="$event.stopPropagation()"></ejs-daterangepicker> -->
			<app-date-range-picker (datePickerChange)="DatePickerChange($event)"></app-date-range-picker>
		</div>
	</mat-menu>
	<mat-menu #filterMenu>
		<div class="filter-switch-div">
			<div class="enabled-switch-div"
				[ngClass]="{'disabled-checkbox': filterData.Unacknowledged || filterData.Archived}">
				<span style="margin-right: 0.2em;">Acknowledged</span>
			</div>
			<mat-checkbox color="primary" (click)="$event.stopPropagation()" (change)="filterAcknowledgedRules($event)"
				[disabled]="filterData.Unacknowledged || filterData.Archived"></mat-checkbox>
			<div class="enabled-switch-div"
				[ngClass]="{'disabled-checkbox': filterData.Acknowledged || filterData.Archived}">
				<span style="margin-right: 0.2em;">Not Acknowledged</span>
			</div>
			<mat-checkbox color="primary" (click)="$event.stopPropagation()"
				(change)="filterUnacknowledgedRules($event)"
				[disabled]="filterData.Acknowledged || filterData.Archived"></mat-checkbox>
			<div class="enabled-switch-div"
				[ngClass]="{'disabled-checkbox': filterData.Unacknowledged || filterData.Acknowledged}">
				<span style="margin-right: 0.2em;">Archived</span>
			</div>
			<mat-checkbox color="primary" (click)="$event.stopPropagation()" (change)="filterArchivedEvents($event)"
				[disabled]="filterData.Unacknowledged || filterData.Acknowledged"></mat-checkbox>
		</div>
	</mat-menu>
	<div class="middle-div alignRow">
		<span class="toolbar-spacer"></span>
		<mat-icon style="cursor: pointer;" *ngIf="selectedLocation"
			(click)="filterByLocation($event, true)">close</mat-icon>
		<div class="location-dropdown">
			<ejs-dropdownlist id="dropdown" #dropdown [dataSource]='MainLocations' placeholder="Select Location"
				[fields]="locationFields" (change)="filterByLocation($event)" [allowFiltering]="true"
				filterType="contains">
				<ng-template #itemTemplate let-data>
					<div>
						<span>{{ data.Name }}</span>
					</div>
				</ng-template>
			</ejs-dropdownlist>
		</div>
	</div>
	<ejs-tab id="element" [selectedItem]="selectedTab" (selected)="tabChange($event)">
		<e-tabitems>
			<e-tabitem #rulesTab>
				<ng-template #headerText>
					<span class="alignRow">
						<mat-icon>rule</mat-icon>&nbsp;Rule Events
					</span>
				</ng-template>
				<ng-template #content>
					<div>
						<ng-container *ngTemplateOutlet="RuleEventsTab"></ng-container>
					</div>
				</ng-template>
			</e-tabitem>
			<e-tabitem>
				<ng-template #headerText>
					<span class="alignRow">
						<mat-icon>sensors_off</mat-icon><span>&nbsp;Sensor Offline Events</span>
					</span>
				</ng-template>
				<ng-template #content>
					<div>
						<ng-container *ngTemplateOutlet="OfflineEventsTab"></ng-container>
					</div>
				</ng-template>
			</e-tabitem>
			<e-tabitem>
				<ng-template #headerText>
					<span class="alignRow">
						<mat-icon>insights</mat-icon>&nbsp;Deviation Events
					</span>
				</ng-template>
				<ng-template #content>
					<div>
						<ng-container *ngTemplateOutlet="DeviationEventsTab"></ng-container>
					</div>
				</ng-template>
			</e-tabitem>
			<e-tabitem>
				<ng-template #headerText>
					<span class="alignRow">
						<mat-icon>webhook</mat-icon>&nbsp;Webhook Events
					</span>
				</ng-template>
				<ng-template #content>
					<div>
						<ng-container *ngTemplateOutlet="WebhookEventsTab"></ng-container>
					</div>
				</ng-template>
			</e-tabitem>
		</e-tabitems>
	</ejs-tab>
</div>

<ng-template #RuleEventsTab>
	<div class="events-list-div">
		<div class="filter-table-div">
			<mat-form-field>
				<mat-label>Search for an Event, Asset, Rule, or Comment</mat-label>
				<input matInput (keyup)="onFilteringRuleEvents($event)" placeholder="" #input>
			</mat-form-field>
			<div *ngIf="dataSourceRule && filteredRuleEvents && filteredRuleEvents.length > 0" class="table-container">
				<table mat-table [dataSource]="dataSourceRule" matSort>
					<ng-container matColumnDef="timestamp" *ngIf="ruleEvents">
						<th mat-header-cell *matHeaderCellDef> Timestamp </th>
						<td style="text-decoration: underline;" mat-cell *matCellDef="let row"
							(click)="selectEvent(row)"> {{convertEpoch(row.TimeStamp)}} </td>
					</ng-container>
					<ng-container matColumnDef="rule">
						<th mat-header-cell *matHeaderCellDef> Triggered by Rule</th>
						<td style="font-weight: bolder;" mat-cell *matCellDef="let row" (click)="selectEvent(row)"> {{
							row.RuleName }}
						</td>
					</ng-container>
					<ng-container matColumnDef="comments">
						<th mat-header-cell *matHeaderCellDef> Comments</th>
						<td class="comments-no-overflow" mat-cell *matCellDef="let row" (click)="selectEvent(row)">
							<span *ngIf="row.Comments.length <= 41">{{ row.Comments }}</span>
							<span *ngIf="row.Comments.length > 41" title="{{row.Comments}}">{{ row.Comments }}</span>
						</td>
					</ng-container>
					<ng-container matColumnDef="acknowledged">
						<th mat-header-cell *matHeaderCellDef> Acknowledged</th>
						<td style="font-weight: bolder; justify-content: center;" mat-cell *matCellDef="let row"
							(click)="selectEvent(row)">
							<span class="alignRow" *ngIf="row.Acknowledged && row.AcknowledgedUser != ''">By {{
								row.AcknowledgedUser }}</span>
							<span class="alignRow" *ngIf="row.Acknowledged && row.AcknowledgedUser != ''">{{
								getDate(row.AcknowledgedTimestamp) }}</span>
							<span class="alignRow" *ngIf="row.Acknowledged && row.AcknowledgedUser == 0">Yes</span>
							<span class="alignRow" style="color: var(--color-red);" *ngIf="!row.Acknowledged">No</span>
						</td>
					</ng-container>
					<ng-container matColumnDef="archiveButton">
						<th mat-header-cell *matHeaderCellDef> Archive</th>
						<td style="justify-content: left;" mat-cell *matCellDef="let row"
							(click)="archiveRuleEvent(row)">
							<span *ngIf="!row.Archived && row.Acknowledged" class="app-icon app-icon--delete"
								matTooltip="Archive event">
								<mat-icon />
							</span>
							<span *ngIf="row.Archived || !row.Acknowledged">
								<mat-icon style="color: lightgray;">delete</mat-icon>
							</span>
						</td>
					</ng-container>
					<ng-container matColumnDef="CaseID">
						<th mat-header-cell *matHeaderCellDef>SAP Case</th>
						<td style="justify-content: left;" mat-cell *matCellDef="let row">
							<mat-icon *ngIf="row.CaseID" style="color: lightgreen;"
								(click)="selectCase(row)">check</mat-icon>
							<mat-icon *ngIf="!row.CaseID" style="color: salmon;">close</mat-icon>
						</td>
					</ng-container>

					<tr mat-header-row *matHeaderRowDef="displayedColumnsRule"></tr>
					<tr mat-row class="table-row" *matRowDef="let row; columns: displayedColumnsRule;"
						style="cursor: pointer;"></tr>
					<tr class="mat-row" *matNoDataRow>
						<td *ngIf="input.value != ''" class="mat-cell" colspan="4">No Data Matching the Filter:
							"{{input.value}}"</td>
						<td *ngIf="input.value == ''" class="mat-cell" colspan="4">No Data Matching the Filter</td>
					</tr>
				</table>
				<mat-paginator #paginatorRule [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="10"
					aria-label="Select page of rules"></mat-paginator>
			</div>
			<div *ngIf="filteredRuleEvents && filteredRuleEvents.length == 0">
				No Rule Events Matching the Filter
			</div>
		</div>
	</div>
</ng-template>

<ng-template #OfflineEventsTab>
	<div class="events-list-div">
		<div class="filter-table-div">
			<mat-form-field>
				<mat-label>Search for an Event</mat-label>
				<input matInput (keyup)="onFilteringOfflineEvents($event)" placeholder="" #input>
			</mat-form-field>
			<div *ngIf="dataSourceOffline && filteredOfflineEvents && filteredOfflineEvents.length > 0"
				class="table-container">
				<table mat-table [dataSource]="dataSourceOffline" matSort>
					<ng-container matColumnDef="timestamp" *ngIf="offlineEvents">
						<th mat-header-cell *matHeaderCellDef> Timestamp </th>
						<td style="cursor: pointer; text-decoration: underline;" mat-cell *matCellDef="let row"
							(click)="selectOfflineEvent(row)"> {{convertEpoch(row.TimeStamp)}} </td>
					</ng-container>
					<ng-container matColumnDef="sensor" style="cursor: pointer;">
						<th mat-header-cell *matHeaderCellDef> Triggered by Sensor</th>
						<td style="cursor: pointer;  font-weight: bolder;" mat-cell *matCellDef="let row"
							(click)="selectOfflineEvent(row)"> {{ row.SensorName }}
						</td>
					</ng-container>
					<ng-container matColumnDef="acknowledged" style="cursor: pointer;">
						<th mat-header-cell *matHeaderCellDef> Acknowledged</th>
						<td style="cursor: pointer;  font-weight: bolder; justify-content: center;" mat-cell
							*matCellDef="let row" (click)="selectEvent(row)">
							<span class="alignRow" *ngIf="row.Acknowledged && row.AcknowledgedUser != ''">By {{
								row.AcknowledgedUser }}</span>
							<span class="alignRow" *ngIf="row.Acknowledged && row.AcknowledgedUser != ''">{{
								getDate(row.AcknowledgedTimestamp) }}</span>
							<span class="alignRow" *ngIf="row.Acknowledged && row.AcknowledgedUser == ''">Yes</span>
							<span class="alignRow" style="color: var(--color-red);" *ngIf="!row.Acknowledged">No</span>
						</td>
					</ng-container>
					<tr mat-header-row *matHeaderRowDef="displayedColumnsOffline"></tr>
					<tr mat-row class="table-row" *matRowDef="let row; columns: displayedColumnsOffline;"></tr>
					<tr class="mat-row" *matNoDataRow>
						<td *ngIf="input.value != ''" class="mat-cell" colspan="4">No Data Matching the Filter:
							"{{input.value}}"</td>
						<td *ngIf="input.value == ''" class="mat-cell" colspan="4">No Data Matching the Filter</td>
					</tr>
				</table>
				<mat-paginator #paginatorOffline [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="10"
					aria-label="Select page of rules"></mat-paginator>
			</div>
			<div *ngIf="filteredOfflineEvents && filteredOfflineEvents.length == 0">
				No Offline Events Matching the Filter
			</div>
		</div>
	</div>
	<!-- <span *ngIf="filteredOfflineEvents">Showing {{filteredOfflineEvents.length}} Events</span>
	<span *ngIf="!isFiltering" style="float: right;"> Showing Events from the Past 24 hours</span> -->
	<!-- <span style="float: right;"
		*ngIf="isFiltering && (formattedStartDate && formattedEndDate) && formattedStartDate != formattedEndDate">Showing
		Events from {{formattedStartDate}} to
		{{formattedEndDate}}</span>
	<span style="float: right;"
		*ngIf="isFiltering && (formattedStartDate && formattedEndDate) && formattedStartDate == formattedEndDate">Showing
		Events from {{formattedStartDate}}</span> -->
</ng-template>

<ng-template #WebhookEventsTab>
	<div class="events-list-div">
		<mat-form-field>
			<mat-label>Search for an Event</mat-label>
			<input matInput (keyup)="onFilteringWebhookEvents($event)" placeholder="" #input>
		</mat-form-field>
		<div *ngIf="dataSourceWebhook && filteredWebhookEvents && filteredWebhookEvents.length > 0"
			class="table-container">
			<table mat-table [dataSource]="dataSourceWebhook" matSort>
				<ng-container matColumnDef="timestamp" *ngIf="webhookEvents">
					<th mat-header-cell *matHeaderCellDef> Timestamp </th>
					<td style="cursor: pointer; text-decoration: underline;" mat-cell *matCellDef="let row"
						(click)="selectWebhookEvent(row)"> {{convertEpoch(row.TimeStamp)}} </td>
				</ng-container>
				<ng-container matColumnDef="webhook" style="cursor: pointer;">
					<th mat-header-cell *matHeaderCellDef> Triggered by Webhook</th>
					<td style="cursor: pointer;  font-weight: bolder;" mat-cell *matCellDef="let row"
						(click)="selectWebhookEvent(row)"> {{ row.Description }}
					</td>
				</ng-container>
				<ng-container matColumnDef="type" style="cursor: pointer;">
					<th mat-header-cell *matHeaderCellDef> Webhook Event Type</th>
					<td style="cursor: pointer;  font-weight: bolder;" mat-cell *matCellDef="let row"
						(click)="selectWebhookEvent(row)"> {{ webhookEventTypeToText(row.WebhookEventType) }}
					</td>
				</ng-container>
				<tr mat-header-row *matHeaderRowDef="displayedColumnsWebhook"></tr>
				<tr mat-row class="table-row" *matRowDef="let row; columns: displayedColumnsWebhook;"></tr>
				<tr class="mat-row" *matNoDataRow>
					<td *ngIf="input.value != ''" class="mat-cell" colspan="4">No Data Matching the Filter:
						"{{input.value}}"</td>
					<td *ngIf="input.value == ''" class="mat-cell" colspan="4">No Data Matching the Filter</td>
				</tr>
			</table>
			<mat-paginator #paginatorWebhook [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="10"
				aria-label="Select page of rules"></mat-paginator>
		</div>
	</div>
	<div *ngIf="filteredWebhookEvents && filteredWebhookEvents.length == 0">
		No Webhook Events Matching the Filter
	</div>
	<!-- <span *ngIf="filteredWebhookEvents">Showing {{filteredWebhookEvents.length}} Events</span>
	<span *ngIf="!isFiltering" style="float: right;"> Showing Events from the Past 30 Days</span> -->
	<!-- <span style="float: right;"
		*ngIf="isFiltering && (formattedStartDate && formattedEndDate) && formattedStartDate != formattedEndDate">Showing
		Events from {{formattedStartDate}} to
		{{formattedEndDate}}</span>
	<span style="float: right;"
		*ngIf="isFiltering && (formattedStartDate && formattedEndDate) && formattedStartDate == formattedEndDate">Showing
		Events from {{formattedStartDate}}</span> -->
</ng-template>

<ng-template #DeviationEventsTab>
	<div class="events-list-div">
		<mat-form-field>
			<mat-label>Search for an Event</mat-label>
			<input matInput (keyup)="onFilteringDeviationEvents($event)" placeholder="" #input>
		</mat-form-field>
		<div *ngIf="dataSourceDeviation && filteredDeviationEvents && filteredDeviationEvents.length > 0"
			class="table-container">
			<table mat-table [dataSource]="dataSourceDeviation" matSort>
				<ng-container matColumnDef="timestamp" *ngIf="deviationEvents">
					<th mat-header-cell *matHeaderCellDef> Timestamp </th>
					<td style="cursor: pointer; text-decoration: underline;" mat-cell *matCellDef="let row"
						(click)="selectDeviationEvent(row)"> {{convertEpoch(row.Timestamp)}} </td>
				</ng-container>
				<ng-container matColumnDef="model" *ngIf="deviationEvents">
					<th mat-header-cell *matHeaderCellDef> Model Type </th>
					<td style="cursor: pointer; font-weight: bolder;" mat-cell *matCellDef="let row"
						(click)="selectDeviationEvent(row)"> {{getModelTypeName(row.ModelType)}} </td>
				</ng-container>
				<ng-container matColumnDef="asset" style="cursor: pointer;">
					<th mat-header-cell *matHeaderCellDef> Asset </th>
					<td style="cursor: pointer;  font-weight: bolder;" mat-cell *matCellDef="let row"
						(click)="selectDeviationEvent(row)"> {{ row.AssetName }} - {{ row.AssetDescription }}
					</td>
				</ng-container>
				<ng-container matColumnDef="zscore" style="cursor: pointer;">
					<th mat-header-cell *matHeaderCellDef> Z-Score</th>
					<td style="cursor: pointer;  font-weight: bolder;" mat-cell *matCellDef="let row"
						(click)="selectDeviationEvent(row)"> {{ row.ZScore }}
					</td>
				</ng-container>
				<ng-container matColumnDef="acceptableDeviation" style="cursor: pointer;">
					<th mat-header-cell *matHeaderCellDef> Tolerance</th>
					<td style="cursor: pointer;  font-weight: bolder;" mat-cell *matCellDef="let row"
						(click)="selectDeviationEvent(row)"> {{ row.AcceptableDeviation }}
					</td>
				</ng-container>
				<ng-container matColumnDef="acknowledged" style="cursor: pointer;">
					<th mat-header-cell *matHeaderCellDef> Acknowledged</th>
					<td style="cursor: pointer;  font-weight: bolder;"
						[ngStyle]="{'color': !row.Acknowledged ? 'Salmon' : ''}" mat-cell *matCellDef="let row"
						(click)="selectDeviationEvent(row)"> {{ row.Acknowledged ? "By " + row.AcknowledgedUser + " on "
						+ getDate(row.AcknowledgedTimestamp) : 'No' }}
					</td>
				</ng-container>
				<tr mat-header-row *matHeaderRowDef="displayedColumnsDeviation"></tr>
				<tr mat-row class="table-row" *matRowDef="let row; columns: displayedColumnsDeviation;"></tr>
				<tr class="mat-row" *matNoDataRow>
					<td *ngIf="input.value != ''" class="mat-cell" colspan="4">No Data Matching the Filter:
						"{{input.value}}"</td>
					<td *ngIf="input.value == ''" class="mat-cell" colspan="4">No Data Matching the Filter</td>
				</tr>
			</table>
			<mat-paginator #paginatorDeviation [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="10"
				aria-label="Select page of rules"></mat-paginator>
		</div>
	</div>
	<div *ngIf="filteredDeviationEvents && filteredDeviationEvents.length == 0">
		No Deviation Events Matching the Filter
	</div>
</ng-template>